const initMap = function() {
  var gmap = document.getElementById("map");

  if (!gmap) return;

  var selectedMap = gmap.getAttribute("data-loc");
  let jsonDatas;
  if (!selectedMap || selectedMap == "") return;
  loadMapDatas(selectedMap);

  const mapStyles = [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36
        },
        {
          color: "#333333"
        },
        {
          lightness: 40
        }
      ]
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on"
        },
        {
          color: "#ffffff"
        },
        {
          lightness: 16
        }
      ]
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe"
        },
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe"
        },
        {
          lightness: 17
        },
        {
          weight: 1.2
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5"
        },
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5"
        },
        {
          lightness: 21
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede"
        },
        {
          lightness: 21
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 17
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 29
        },
        {
          weight: 0.2
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 18
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff"
        },
        {
          lightness: 16
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2"
        },
        {
          lightness: 19
        }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          visibility: "on"
        },
        {
          gamma: "0.82"
        },
        {
          lightness: "-6"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9"
        },
        {
          lightness: 17
        }
      ]
    }
  ];

  const setupMap = function() {
    const center = jsonDatas.center;
    const markersInfos = jsonDatas.markers;
    const polygons = jsonDatas.polygons;
    let infowindows = [];

    window.map = new google.maps.Map(gmap, {
      zoom: 15,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: false
    });

    google.maps.event.addDomListener(
      window,
      "resize",
      map.setCenter.bind(map, center)
    );

    function closeAllInfoWindows() {
      for (var i = 0; i < infowindows.length; i++) {
        infowindows[i].close();
      }
    }

    markersInfos.forEach(function(markerInfos) {
      var marker = new google.maps.Marker({
        position: markerInfos.position,
        map: map,
        icon: "/assets/front/gmap_pin" + markerInfos.marker + ".png",
        title: markerInfos.title
      });

      var infowindow = new google.maps.InfoWindow({
        content:
          '<div id="content"><div id="siteNotice"></div><h1 id="infow-heading" class="infow-heading">' +
          markerInfos.title +
          "</h1></div>"
      });

      infowindows.push(infowindow);

      marker.addListener("click", function() {
        closeAllInfoWindows();
        infowindow.open(map, marker);
      });
    });

    for (var i = 0; i < polygons.length; i++) {
      new google.maps.Polygon({
        paths: polygons[i].paths,
        strokeColor: polygons[i].strokeColor,
        strokeOpacity: polygons[i].strokeOpacity,
        strokeWeight: polygons[i].strokeWeight,
        fillColor: polygons[i].fillColor,
        fillOpacity: polygons[i].fillOpacity,
        cursor: "default"
      }).setMap(map);
    }

    var latlngbounds = new google.maps.LatLngBounds();

    markersInfos.forEach(function(markerInfos) {
      latlngbounds.extend(
        new google.maps.LatLng(
          markerInfos.position.lat,
          markerInfos.position.lng
        )
      );
    });

    polygons.forEach(function(polygon) {
      polygon.paths.forEach(function(path) {
        latlngbounds.extend(new google.maps.LatLng(path.lat, path.lng));
      });
    });

    //latlngbounds.extend(new google.maps.LatLng(48.923000, 2.357583));

    var centerAndFitMap = function() {
      map.setCenter(latlngbounds.getCenter());
      map.fitBounds(latlngbounds);
      var listener = google.maps.event.addListener(map, "idle", function() {
        if (map.getZoom() < 13) map.setZoom(13);
        map.setCenter(latlngbounds.getCenter());
        google.maps.event.removeListener(listener);
      });
    };

    google.maps.event.addDomListener(window, "resize", centerAndFitMap);

    centerAndFitMap();

    // DISPLAY CAPTION
    if (jsonDatas.caption.length > 0) {
      let caption = document.createElement("div");
      caption.className = "gmap_caption";
      jsonDatas.caption.forEach(function(el) {
        let div = `<div class="marker ${el.marker}">${el.title}</div>`;
        caption.innerHTML += div;
      });
      gmap.parentNode.append(caption);
    }
  };

  function loadMapDatas(selectedMap) {
    fetch(`/assets/front/${selectedMap}.json`, {
      headers: { "Content-Type": "application/json; charset=utf-8" },
      credentials: "same-origin"
    })
      .then(res => res.json()) // parse response as JSON
      .then(response => {
        // here you do what you want with response
        jsonDatas = response;
        setupMap();
      })
      .catch(err => {
        console.log(err);
        alert("sorry, there are no results for your search");
      });
  }
};

window.initMap = initMap;
